import { render } from "./DiveTextаrea.vue?vue&type=template&id=18ed7e40&scoped=true"
import script from "./DiveTextаrea.vue?vue&type=script&lang=js"
export * from "./DiveTextаrea.vue?vue&type=script&lang=js"

import "./DiveTextаrea.vue?vue&type=style&index=0&id=18ed7e40&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ed7e40"]])

export default __exports__